/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Nehnutelnosti_SkInputs */

const cs_enum_nehnutelnosti_sk = /** @type {(inputs: Enum_Nehnutelnosti_SkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehnutelnosti.sk`)
};

const en_enum_nehnutelnosti_sk = /** @type {(inputs: Enum_Nehnutelnosti_SkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehnutelnosti.sk`)
};

/**
* | output |
* | --- |
* | "Nehnutelnosti.sk" |
*
* @param {Enum_Nehnutelnosti_SkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_nehnutelnosti_sk = /** @type {((inputs?: Enum_Nehnutelnosti_SkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Nehnutelnosti_SkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_nehnutelnosti_sk(inputs)
	return cs_enum_nehnutelnosti_sk(inputs)
});